import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./BannerComponent.scss";

const BannerComponent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
    document.body.style.overflow = "hidden"; // Prevent background scrolling
  };

  const closeModal = () => {
    setIsModalOpen(false);
    document.body.style.overflow = "unset"; // Restore scrolling
  };

  return (
    <>
      <section className="banner">
        <div className="container">
          <div className="banner-content">
            <h2>Bradford-on-Avon Later Life Support</h2>
            <h3>
              Providing a befriending, companionship and respite service in the
              Bradford-on-Avon area.
            </h3>
            <div className="leaflet-images">
              <img
                src="/leaflet page 1.jpg"
                alt="BoA Leaflet Page 1"
                onClick={openModal}
                title="Click to view full leaflet"
              />
              <img
                src="/leaflet page 2.jpg"
                alt="BoA Leaflet Page 2"
                onClick={openModal}
                title="Click to view full leaflet"
              />
            </div>
            <Link to="/about" className="banner-button">
              Find out more
            </Link>
          </div>
        </div>
      </section>

      {isModalOpen && (
        <div className="pdf-modal" onClick={closeModal}>
          <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="pdf-modal-close" onClick={closeModal}>
              ×
            </button>
            <iframe
              src="/Gareth BOA leaflet 2026.pdf#toolbar=0&navpanes=0&view=FitH"
              title="BoA Leaflet"
              className="pdf-viewer"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default BannerComponent;
